import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Forside from './pages/Forside';
import ForloebPriser from './pages/ForloebPriser';
import Mindsetforloeb from './pages/Mindsetforloeb';
import OmMig from './pages/OmMig';
import Kontakt from './pages/Kontakt';

// Helper component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900 antialiased selection:bg-sky-100 selection:text-blue-900">
      <ScrollToTop />
      
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/forloeb-og-priser" element={<ForloebPriser />} />
          <Route path="/mindsetforloeb" element={<Mindsetforloeb />} />
          <Route path="/om-mig" element={<OmMig />} />
          <Route path="/kontakt" element={<Kontakt />} />
          {/* Fallback route */}
          <Route path="*" element={<Forside />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
